export default from './user-avatar-image';



// WEBPACK FOOTER //
// ./app/components/user-avatar-image/index.js